//====================================================
//  Function: Slider
//====================================================
var mySwiper;
function productFavoriteSlider() {
  if ($(".js-slider-products-favorite").length) {
    var inst = $(".js-slider-products-favorite"),
      swiperBlock = inst.closest(".js-slider-group"),
      swiperPagination = swiperBlock.find(".js-swiper-pagination");

    mySwiper = new Swiper(inst, {
      spaceBetween: 30,
      lazy: true,
      // loop: true,
      speed: 600,
      // autoplay: {
      //   delay: 4000,
      //   disableOnInteraction: true,
      // },
      pagination: {
        el: swiperPagination,
        clickable: true,
      },
      breakpoints: {
        200: {
          slidesPerColumnFill: "column",
          slidesPerColumn: 1,
          slidesPerView: 1,
          slidesPerGroup: 1,
        },
        576: {
          slidesPerColumnFill: "row",
          slidesPerColumn: 1,
          slidesPerView: 3,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerColumnFill: "row",
          slidesPerColumn: 2,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        992: {
          slidesPerColumnFill: "row",
          slidesPerView: 2,
          slidesPerColumn: 2,
          slidesPerGroup: 2,
        },
        1200: {
          slidesPerColumnFill: "row",
          slidesPerView: 3,
          slidesPerColumn: 2,
          slidesPerGroup: 3,
        },
      },
    });
  }
}

var mySwiperHomeProducts1;
var mySwiperHomeProducts2;
var mySwiperHomeProducts3;
var mySwiperHomeProducts4;

function productHomeSlider(index) {
  if (index == 1) {
    var inst = $(".js-slider-products-home-1"),
      swiperBlock = inst.closest(".js-slider-group"),
      swiperPaginations = swiperBlock.find(".js-swiper-paginations");

    mySwiperHomeProducts1 = new Swiper(inst, {
      spaceBetween: 30,
      lazy: true,
      speed: 600,
      pagination: {
        el: swiperPaginations,
        clickable: true,
      },
      on: {
        init: function () {
          // $(window).resize();
        },
      },
    });
  }
  // if (index == 2) {
  //   var inst = $(".js-slider-products-home-2"),
  //     swiperBlock = inst.closest(".js-slider-group"),
  //     swiperPagination = swiperBlock.find(".js-swiper-pagination");

  //   mySwiperHomeProducts2 = new Swiper(inst, {
  //     spaceBetween: 30,
  //     lazy: true,
  //     speed: 600,
  //     pagination: {
  //       el: swiperPagination,
  //       clickable: true,
  //     },
  //     on: {
  //       init: function () {
  //         $(window).resize();
  //       },
  //     },
  //   });
  // }
  // if (index == 3) {
  //   var inst = $(".js-slider-products-home-3"),
  //     swiperBlock = inst.closest(".js-slider-group"),
  //     swiperPagination = swiperBlock.find(".js-swiper-pagination");

  //   mySwiperHomeProducts3 = new Swiper(inst, {
  //     spaceBetween: 30,
  //     lazy: true,
  //     speed: 600,
  //     pagination: {
  //       el: swiperPagination,
  //       clickable: true,
  //     },
  //     on: {
  //       init: function () {
  //         $(window).resize();
  //       },
  //     },
  //   });
  // }
  // if (index == 4) {
  //   var inst = $(".js-slider-products-home-4"),
  //     swiperBlock = inst.closest(".js-slider-group"),
  //     swiperPagination = swiperBlock.find(".js-swiper-pagination");

  //   mySwiperHomeProducts4 = new Swiper(inst, {
  //     spaceBetween: 30,
  //     lazy: true,
  //     speed: 600,
  //     pagination: {
  //       el: swiperPagination,
  //       clickable: true,
  //     },
  //     on: {
  //       init: function () {
  //         $(window).resize();
  //       },
  //     },
  //   });
  // }
}

function productRelatedSlider() {
  var inst = $(".js-slider-products-detail"),
    swiperBlock = inst.closest(".js-slider-group"),
    swiperPagination = swiperBlock.find(".js-swiper-pagination");

  mySwiperRelatedProducts = new Swiper(inst, {
    spaceBetween: 30,
    lazy: true,
    speed: 600,
    pagination: {
      el: swiperPagination,
      clickable: true,
    },
    on: {
      init: function () {
        $(window).resize();
      },
    },
    breakpoints: {
      200: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 2,
      },
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 3,
      },
    },
  });
}
